import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { UtilsService } from '@services/utils.service';
import { UrlUtil } from '@shared/functions/UrlUtil';

export interface DriverDepositReturnsParams {
    startDate: string;
    endDate: string;
    reportType?: string;
    returnCollected?: boolean | null;
    depots?: number[];
    driverId?: string;
}

@Injectable({
    providedIn: 'root'
})
export class DriverDepositReportService {
    protected static DRIVER_DEPOSIT_RETURNS_CSV: string = `${environment.api.url}${environment.api.prefix}/report/v2/driverDepositReturns/csv`;

    constructor(
        protected http: HttpClient,
        protected utilsService: UtilsService
    ) {}

    public exportDriverDepositReturnsCsv(params: DriverDepositReturnsParams): Observable<Blob> {
        const queryParams: any = {
            startDate: params.startDate,
            endDate: params.endDate
        };

        if (params.reportType) {
            queryParams.reportType = params.reportType;
        }

        if (params.returnCollected !== undefined) {
            queryParams.returnCollected = params.returnCollected;
        }

        if (params.driverId) {
            queryParams.driverId = params.driverId;
        }

        // Handle depots array as single parameter with comma-separated values (depots=1,2,3)
        if (params.depots && params.depots.length > 0) {
            queryParams.depots = params.depots.join(',');
        }

        const queryString = UrlUtil.objectToString(queryParams);
        const endpoint = `${DriverDepositReportService.DRIVER_DEPOSIT_RETURNS_CSV}?${queryString}`;

        const HTTPOptions = {
            headers: new HttpHeaders({
                'Accept': 'text/plain'
            }),
            responseType: 'blob' as 'json'
        };

        return this.http.get<any>(endpoint, HTTPOptions);
    }
}

